/**
 * Single source of truth for all Tag / status / role colors.
 *
 * Values are Ant Design Tag color names. Do NOT redeclare these maps inside
 * pages — import from here (or use <StatusTag /> which reads them for you).
 */
export { EVENT_STATUS_LIST, EVENT_STATUS_TAG_COLOR, EVENT_STATUS_LABEL, getEventStatusTagColor, getEventStatusLabel } from './eventStatus';

export const ROLE_COLORS: Record<string, string> = {
    SUPER_ADMIN: 'red',
    INSTITUTION_ADMIN: 'purple',
    FEST_ADMIN: 'magenta',
    ITEM_COORDINATOR: 'geekblue',
    JUDGE: 'orange',
    VOLUNTEER: 'cyan',
    PARTICIPANT: 'blue',
};

export const USER_STATUS_COLORS: Record<string, string> = {
    ACTIVE: 'green',
    INACTIVE: 'default',
    SUSPENDED: 'red',
};

export const FEST_STATUS_COLORS: Record<string, string> = {
    DRAFT: 'default',
    ACTIVE: 'green',
    PUBLISHED: 'blue',
    COMPLETED: 'blue',
    CANCELLED: 'red',
};

export const RESULT_STATUS_COLORS: Record<string, string> = {
    DRAFT: 'default',
    PUBLISHED: 'green',
    LOCKED: 'red',
};

export const EVENT_TYPE_COLORS: Record<string, string> = {
    INDIVIDUAL: 'blue',
    GROUP: 'purple',
};

export const GRADE_COLORS: Record<string, string> = {
    'A+': 'purple',
    A: 'blue',
    'B+': 'green',
    B: 'cyan',
    'C+': 'gold',
    C: 'orange',
    D: 'red',
};

/** Per-participant scoring status (SCORED / ABSENT / PENDING / PARTIAL). */
export const SCORE_STATUS_COLORS: Record<string, string> = {
    SCORED: 'success',
    ABSENT: 'error',
    PENDING: 'warning',
    PARTIAL: 'processing',
};

export const SCORE_STATUS_LABELS: Record<string, string> = {
    SCORED: 'Scored',
    ABSENT: 'Absent',
    PENDING: 'Pending',
    PARTIAL: 'Judging In Progress',
};

/** Medal colors (hex) for poster template rank badges (1st / 2nd / 3rd). */
export const POSTER_RANK_COLORS: Record<number, string> = {
    1: '#EF9F27',
    2: '#B4B2A9',
    3: '#D85A30',
};

export const PLAN_BADGE_COLORS: Record<string, string> = {
    TRIAL: 'cyan',
    BASIC: 'default',
    CURRENT_PLAN: 'green',
    POPULAR: 'gold',
    LIMITED_TIME_OFFER: 'volcano',
    ULTRA: 'purple',
};
